import { logUsage } from 'owa-analytics';
import { getSwipeRightAction, getSwipeLeftAction } from 'owa-mail-list-swipe-utils';
import type MailSwipeAction from 'owa-service/lib/contract/MailSwipeAction';
import { getStore as getListViewStore } from 'owa-mail-list-store';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { getMailboxInfoFromTableViewId } from 'owa-mail-mailboxinfo/lib/getMailboxInfo';

export const skipHandleTouchCallback = (moveX?: number): boolean => {
    if (moveX === undefined) {
        return true;
    }
    if (moveX === 0) {
        return false;
    }
    const isSwipeRight = moveX > 0;
    const swipeAction = isSwipeRight ? getSwipeRightAction() : getSwipeLeftAction();

    return swipeAction === 0;
};

export const logSwipeAction = (
    isSwipeRight: boolean,
    swipeAction: MailSwipeAction,
    rowKeyOrNodeId: string,
    tableViewId: string,
    isItemPart: boolean
): void => {
    const tableView = getListViewStore().tableViews.get(tableViewId);
    const folderId = tableView?.tableQuery?.folderId;
    const folderName = folderId ? folderIdToName(folderId) : 'none';

    logUsage('SwipeMailListItem', getMailboxInfoFromTableViewId(tableViewId), {
        isSwipeRight,
        swipeAction,
        tableType: tableView?.tableQuery?.type,
        listViewType: tableView?.tableQuery?.listViewType,
        folderName,
        rowKeyOrNodeId,
        isItemPart,
    });
};
